export default __webpack_public_path__ + "static/media/road-hazard-accident-shadow.0b33ae5e.svg";